// class BrixSearchResult {
//   static init(...parameters) {
//     return new BrixSearchResult(...parameters);
//   }

//   constructor(selector) {
//     this.selector = selector;

//     console.log('Search result');
//   }
// }

// // Register class
// if (window.brix && window.brix.registerBlock) {
//   window.brix.registerBlock('brix-search-result', BrixSearchResult.init);
// }
